var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-exporter"},[_vm._t("default",function(){return [(_vm.showButton)?_c('button',{class:_vm.buttonClass,attrs:{"disabled":_vm.isExporting},on:{"click":_vm.handleExport}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }